import { render, staticRenderFns } from "./ngo-admin.vue?vue&type=template&id=1331d358&scoped=true&"
import script from "./ngo-admin.vue?vue&type=script&lang=js&"
export * from "./ngo-admin.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin.vue?vue&type=style&index=0&id=1331d358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331d358",
  null
  
)

export default component.exports